"use strict";

window.loadJustificationDialogScript = (isWorklistOrder = false) => {
    $('#divJustification').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: "#contentView",
        title: $("<div/>").html(justificationLabel).text(),
        dialogClass: 'no-close, justificationDialog',
        position: { my: "center", at: "center", of: $("#subPageContent") }
    })

    $('body').off('click', '.tdJustification');
    $('body').on('click', '.tdJustification' ,function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('.justificationWrapper').empty();

        $('.activeRow').removeClass('activeRow');
        $(this).parent().addClass('activeRow');

        var orderNumber = $(this).parent().find('span.orderNumber').text();
        var orderID = $(this).parent().find('span.id').text();
        var orderStatusID = $(this).closest('tr').children('td').children('.orderStatusUID').text();
        var patientID = $(this).parent().find('span.patientID').text();
        var patientTitle = $(this).parent().find('span.patientWithGender').text();
        var patientDOB = $(this).parent().find('span.dateOfBirth').text();
        $('#divJustification input#orderID').val(orderID);
        var toAppend = 'a';

        $.ajax({
            traditional: true,
            type: 'GET',
            url: '/legacy/System/GetProceduresForJustification',
            data: {
                Order_UID: orderID,
                Patient_UID: patientID
            },
            dataType: 'json',
            async: false,
            success:
                function (data) {
                    if (data.AllOk) {
                        if (data.List.length > 0) {
                            $.each(data.List, function (i, proc) {
                                //repeat following for each procedure
                                toAppend = '<div class="justificationProcedure">';
                                toAppend += '<input type="hidden" class="orderProcedureID" value="' + proc.OrderProcedure_UID + '"/>';
                                toAppend += '<div class="procedureName">';
                                toAppend += '<p class="procedure" style="background-color:' + proc.ProcedureColor + '">'
                                    + '<b>' + htmlEncode(proc.ProcedureModality) + '</b> '
                                    + htmlEncode(proc.ProcedureCode) + ' (' + htmlEncode(proc.ProcedureFullCode) + ') '
                                    + htmlEncode(proc.ProcedureDescription)
                                    + '</p>';
                                toAppend += '</div>';

                                toAppend += '<select class="selectJustificationRemark">';
                                toAppend += '<option value="-1">' + htmlEncode(selectJustificationLabel) + '</option>';
                                $.each(proc.Remarks, function (counter, y) {
                                    toAppend += '<option class="remarkToChoose"'
                                        + ' title="' + htmlEncode(y.Remark) + '"'
                                        + ' value="' + htmlEncode(y.Remark) + '">'
                                        + htmlEncode(y.Name)
                                        + '</option>';
                                });
                                toAppend += '</select>';

                                toAppend += '<textarea class="text-box clearfix justificationRemarks" cols="30" rows="5">' + htmlEncode(proc.Justification) + '</textarea>';
                                toAppend += '<div class="justificationInfo">';
                                if (proc.JustificationUsername) {
                                    toAppend += '<label class="justificationUsername">*<span class="username">'
                                        + htmlEncode(proc.JustificationUsername) + ' '
                                        + htmlEncode(proc.JustificationDatetimeString)
                                        + '</span></label>';
                                }
                                if (proc.Required) {
                                    toAppend += '<label class="justificationRequired"><input class="clearfix" type="checkbox" checked="checked"/><span>'
                                        + htmlEncode(window.Resources.Required)
                                        + '</span></label>';
                                } else {
                                    toAppend += '<label class="justificationRequired"><input class="clearfix" type="checkbox"/><span>'
                                        + htmlEncode(window.Resources.Required)
                                        + '</span></label>';
                                }

                                toAppend += '</div>';

                                toAppend += '<div class="justificationStatus">';
                                toAppend += statusesDropdown;
                                toAppend += '</div>';

                                if (i < data.List.length - 1) {
                                    toAppend += '<hr>';
                                }

                                toAppend += '</div>';
                                $('.justificationWrapper').append(toAppend);
                                $('.justificationWrapper').find('#DDLJustificationStatus option[value="' + proc.ChangeToStatus + '"]').attr("selected", "selected");
                                $('.justificationWrapper').find('#DDLJustificationStatus option[value="' + proc.ChangeToStatus + '"]').prop("disabled", false);
                            });
                        }
                    }
                }
        });
        $('#divJustification').dialog({
            title: justificationLabel + " - " + patientTitle + " " + patientDOB + " (" + orderNumber + ")"
        }).dialog('open');
    });

    $('#btnCloseJustification').on('click', function () {
        $('#divJustification').dialog('close');
    });

    $('#btnOKJustification').on('click', function () {
        if (!$('#divJustification textarea.justificationRemarks').is(':disabled')) {
            //save justification for each procedure that needs it

            var justificationModels = [];

            $('.justificationProcedure').each(function (i, y) {
                var opID = $(this).find('input.orderProcedureID').val();
                var text = $(this).find('textarea.justificationRemarks').val();
                var changeToStatus = $(this).find('#DDLJustificationStatus').val();
                var required = $(this).find('.justificationRequired input').is(':checked');
                var jModel = {
                    OrderProcedure_UID: opID,
                    Justification: text,
                    ChangeToStatus: changeToStatus,
                    Required: required
                };

                justificationModels.push(jModel);
            });

            $.ajax({
                type: 'POST',
                url: '/legacy/System/SaveJustifications',
                data: JSON.stringify(justificationModels),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                async: true,
                success:
                    function (data) {
                        if (data.AllOk) {
                            //reload the list
                            if(!isWorklistOrder)
                                ReportWorklistSharedFunctions.refreshTable();
                            else
                                refreshTable();
                        }
                    }
            });
        }
        else {
            $('textarea.justificationRemarks').empty();
        }

        $('#divJustification').dialog('close');
    });

    $('body').off('change', '.selectJustificationRemark');
    $('body').on('change', '.selectJustificationRemark', function (e) {
        if ($(this).val() !== -1 && $(this).val() != null) {
            var toAppend = $(this).val();
            var remarksarea = $(this).parent().find('textarea.justificationRemarks');
            if (remarksarea.val() !== "") {
                toAppend = " " + toAppend;
            }
            remarksarea.val(remarksarea.val() + toAppend);
            $(this).val(-1);
        }
    });
};
